export function getLocale() {
    return document.querySelector("body").dataset.locale;
}

export function getLang(locale) {
    switch (locale) {
        case "en":
            return "en-GB"
        case "de":
            return "de-DE"
        case "pl":
            return "pl-PL"
        default:
            return "cs-CZ"
    }
}

export function getCalendarTooltips(locale) {
    switch (locale) {
        case "en":
            return {
                one: 'night',
                few: 'nights',
                other: 'nights'
            }
        case "de":
            return {
                one: 'Nacht',
                few: 'Nächte',
                other: 'Nächte'
            }
        case "pl":
            return {
                one: 'noc',
                few: 'noce',
                other: 'nocy'
            }
        default:
            return {
                one: 'noc',
                few: 'noci',
                other: 'nocí'
            }
    }
}

export function getCurrencyFromLocale(locale) {
    switch (locale) {
        case "en":
        case "de":
        case "pl":
            return "EUR"
        default:
            return "Kč"
    }
}